var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNumTimer9 = function SvgNumTimer9(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF3",
    d: "M1.912 25.112h11.856v-5.4H4.816q-1.68 0-2.472-.768-.768-.768-.768-2.472v-5.616q0-3.336 3.312-3.336H15.04q3.336 0 3.336 3.336v14.808Q18.376 29 15.04 29H1.912zm11.856-9.192v-4.512H6.184v4.512z"
  })));
};
export default SvgNumTimer9;